import React from 'react';
import moment from 'moment';

export default class AccrualItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isElementVisible: [],

        }
        this.toggleVisibility = this.toggleVisibility.bind(this);
    }
    toggleVisibility(index) {
        let isElementVisible = this.state.isElementVisible.slice(0);
        isElementVisible[index] = !isElementVisible[index];
        this.setState({ isElementVisible });
    }

    render() {
        let accrualSummary = this.props.accrualSummary.sort((o) => o.accrualDescription);
        let content = [];
        for (let i = 0; i < accrualSummary.length; i++) {
            let item = accrualSummary[i];

            if (this.props.mode == 'Summary')
                content.push(
                        <div className={`col-xs-${12/accrualSummary.length} col-md-${12/accrualSummary.length} ap-accrual-summary`} key={item.accrualDescription + "_" + i}>
                            <div className="row">
                                <div className="col-xs-12 col-md-12 ap-accrual-summary-title">
                                    {item.accrualDescription}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-8 col-md-4 col-md-offset-3">
                                    Accrued Hours
                                </div>
                                <div className="col-xs-4 col-md-2">
                                    {item.totalAccruedHours}
                                </div>
                                <div className="hidden-xs col-md-3">
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-8 col-md-4 col-md-offset-3">
                                    Logged Hours
                                </div>
                                <div className="col-xs-4 col-md-2">
                                    {item.loggedHours}
                                </div>
                                <div className="hidden-xs col-md-3">
                                </div>
                            </div>
                            <div className="row ap-text-bold">
                                <div className="col-xs-8 col-md-4 col-md-offset-3">
                                    Available Hours
                                </div>
                                <div className="col-xs-4 col-md-2">
                                    {item.availableHours}
                                </div>
                                <div className="hidden-xs col-md-3">
                                </div>
                            </div>
                        </div>
                    );

            else // with collapsible details
                content.push(
                    <div className="row" key={item.accrualDescription + "_" + i}>
                        <div className="col-md-12">
                            <div className="col-md-3 text-left">
                                <span onClick={() => this.toggleVisibility(i)} className={this.state.isElementVisible[i] ? "fa fa-minus-square-o ap-good-color ap-pointer" : " fa fa-plus-square-o ap-good-color ap-pointer"}> </span> &nbsp;&nbsp;
                                {item.accrualDescription}
                            </div>
                            <div className="col-md-3">
                                {item.totalAccruedHours}
                            </div>
                            <div className="col-md-3">
                                {item.loggedHours}
                            </div>
                            <div className="col-md-3">
                                {item.availableHours}
                            </div>
                            <br /> <br />
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-md-8">
                                        {this.state.isElementVisible[i] ?
                                            <AccrualLogRow accrualLogs={item.accrualLogs} group={item.accrualDescription} /> : null
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
        }

        if (this.props.mode == "Summary")
            return (
                    <div className="col-md-12 ap-accrual">
                        {content}
                    </div>
                    );
        else
            return (
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="container-fluid ap-paystubgrid-header">
                                <div className="row">
                                    <div className="col-md-3 col-md-offset-3">
                                        Total Accrued Hours
                                    </div>
                                    <div className="col-md-3">
                                        Logged Hours
                                    </div>
                                    <div className="col-md-3">
                                        Available Hours
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {content}
                 </div>
            );
    }

}
class AccrualLogRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    render() {
        const accrualLogs = this.props.accrualLogs
        const group = this.props.group;
        let counter = 0;
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="col-md-2">
                        Date
                    </div>
                    <div className="col-md-2">
                        Hours Logged
                    </div>
                    <div className="col-md-2">
                        Status
                    </div>
                    <div className="col-md-6">
                        Comments
                    </div>
                </div>
                <br />
                {accrualLogs
                    .sort((a, b) => new Date(b.fromDate).getTime() - new Date(a.fromDate).getTime())
                    .map(item => {
                    return (
                        <div className="col-md-12" key={group + '_' + counter++}>
                            <div className="col-md-2">
                                {moment(item.fromDate).format('MM/DD/YYYY')}
                            </div>
                            <div className="col-md-2">
                                {item.loggedHours}
                            </div>
                            <div className="col-md-2">
                                {item.pending == "Y" ? "Pending" : "Processed"}
                            </div>
                            <div className="col-md-6">
                                {item.comment}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}
